import { Contact } from "src/services/contacts/contacts.types";
import { User } from "src/services/organisation/organisation.types";
import { IOrgCandidate } from "src/services/candidates/candidates.types";
import { ICompanyProfile } from "src/services/connections/connections.types";


export enum ListEntityType {
  COMPANY = 'company',
  CONTACT = 'contact',
  CANDIDATE = 'candidate',
}

export type List = {
  id: string;
  name: string;
  description: string;
  entity_type: ListEntityType;
  entity_count: number;
  owner: Partial<User>;
  access_list: Partial<User>[];
  register_via_job_board?: boolean;
  // JT1-1276 Phase 1: 'website_registrations' for the hardcoded system list, null for user lists.
  system_type?: string | null;
  created_at: Date;
  updated_at: Date;
}

export type ListItem = {
  id: string;
  contact?: Contact;
  organization_candidate?: IOrgCandidate;
  company_profile?: ICompanyProfile;
}

export interface CreateListDto {
  name: string;
  description?: string;
  entity_type: ListEntityType;
  access_list: string[];
  entities: string[];
  register_via_job_board?: boolean;
}

export interface UpdateListDto {
  name: string;
  description?: string;
  access_list: string[];
  register_via_job_board?: boolean;
}

export interface UpdateListItemsDto {
  entities: string[];
}

export interface RemoveListItemsDto {
  item_ids: string[];
}

export interface UpdateListAccessDto {
  account_ids: string[];
}

export interface UpdateListOwnerDto {
  account_id: string;
}

// JT1-1276 Phase 4: payload for moving entities from a source list into a target list.
export interface MoveListItemsDto {
  source_list_id: string;
  entities: string[];
}